import { isDefined, isEmpty, isNotDefined } from '@sgme/fp';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useUserContext } from '@/context/UserContext.tsx';
import { accumulatorTypes, type BlotterProductType } from '@/store/blotter/api/types/BlotterTradeEntry.ts';

interface BlotterEntryDuck {
  id: string;
  venue: string;
  strategyReference: string | null;
  product: string;
  clientId: number | null;
}

type Props = {
  entry: BlotterEntryDuck;
  onClick: () => void;
};

export const RepriceQuoteButton = ({ entry, onClick }: Props) => {
  const { formatMessage } = useIntl();

  const {
    currentUser: { clients },
  } = useUserContext();

  const repriceIsUnavailable = useMemo<boolean>(() => {
    const userClientIds = clients.map((client) => client.companyId);
    return (
      isNotDefined(entry) ||
      entry.venue !== 'SG-MARKETS' ||
      (isDefined(entry.strategyReference) && !isEmpty(entry.strategyReference)) ||
      (accumulatorTypes as unknown as BlotterProductType).includes(entry.product) ||
      (isDefined(entry.clientId) && !userClientIds.includes(entry.clientId))
    );
  }, [entry, clients]);

  if (repriceIsUnavailable) {
    return null;
  }

  return (
    <span title={formatMessage({ id: 'blotter.column.actions.repriceQuote' })}>
      <button type="button" className="btn btn-link btn-icon p-0" onClick={onClick} data-e2e="reprice-quote-button">
        <i className="icon icon-sm">filter_none</i>
      </button>
    </span>
  );
};
